import type { NodeTypeCounts } from '@amarantos/api-client'
import { NodeType } from '@amarantos/api-client'

/**
 * Display order for the counts, taken from the generated enum so a node type added to the API
 * shows up in the breakdown instead of silently dropping out of it.
 */
const nodeTypeOrder = Object.values(NodeType)

export interface NodeTypeCount {
	type: NodeType
	count: number
}

/** The contract's counts object as an ordered list — a keyed object has no display order. */
export function toNodeTypeCounts(counts: NodeTypeCounts): NodeTypeCount[] {
	return nodeTypeOrder.map((type) => ({ type, count: counts[type] }))
}

/** Only the types a scope actually has — six zeros say less than the two lines that carry data. */
export function toPresentNodeTypeCounts(counts: NodeTypeCounts): NodeTypeCount[] {
	return toNodeTypeCounts(counts).filter(({ count }) => count > 0)
}
